import { useQuery } from '@tanstack/react-query'

import { fetchLatestTrend } from '../api/trendsClient'
import type { TrendReport } from '../model/contracts'

export function useLatestTrend() {
  return useQuery<TrendReport>({
    queryKey: ['trends', 'latest'],
    queryFn: ({ signal }) => fetchLatestTrend(signal),
    staleTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
  })
}
